import { DepositApi, InvoiceApi, LimitSummaryAPIModel, SbpInvoiceAPIModel } from '@/generated/api/fps/core';
import { MoneyType } from '@/model/common';
import { InvoiceDetails, Limits } from '@/model/invoice/types';

import { coreConfigurationFactory } from './utils/auth.provider';
import { parsePhone } from './utils/phone';

const depositApi = new DepositApi(coreConfigurationFactory('auth'));
const invoiceApi = new InvoiceApi(coreConfigurationFactory('auth'));

export const parseInvoice = ({ allocatedPhone, ...data }: SbpInvoiceAPIModel): InvoiceDetails => ({
  ...data,
  allocatedPhone: parsePhone(allocatedPhone.phone),
});

export const parseMoney = (amount: string): MoneyType => (amount ? Math.round(parseFloat(amount) * 100) : 0);

export const parseLimits = ({ monthly, oneTime }: LimitSummaryAPIModel): Limits => ({
  oneTime: oneTime ? { ...oneTime, amount: parseMoney(oneTime.amount) } : undefined,
  monthly: monthly
    ? {
        ...monthly,
        amount: parseMoney(monthly.amount),
        currentAmount: parseMoney(monthly.currentAmount),
        updatedAt: new Date(monthly.updatedAt),
      }
    : undefined,
});

export const queryLimits = async (): Promise<Limits> => parseLimits(await depositApi.getSBPLimits());

export const queryInvoice = async (): Promise<InvoiceDetails> =>
  parseInvoice((await invoiceApi.getSbpInvoice()).invoice);

export const createInvoice = async (): Promise<InvoiceDetails> =>
  parseInvoice((await invoiceApi.createSbpInvoice()).invoice);
